import React, { useEffect, useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import moTheme from '@ecp/common/src/style/theme/mo';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { SwiperContents } from '@ecp/common/src/components/swiper/mo/SwiperTemplate';

import { getIsLogin } from '@mo-recoil/common/user/selector';
import displayRecommendationApi from '@mo-apis/display/displayRecommendationApi';
import { MainContentsTitle } from '@mo-components/styled';
import GoodCardCarouselItem from '@mo-components/good/GoodCardCarouselItem';

const AiBasedRecommendation = ({ title, displayCategoryNumber, channel, handleVisibility }) => {
  const theme = useTheme();
  const [tags, setTags] = useState([]);
  const [goodList, setGoodList] = useState([]);
  const login = useRecoilValue(getIsLogin);

  useEffect(() => {
    if (!login) return;
    (async () => {
      const {
        result: { interestList = [], goodList = [] },
      } = await displayRecommendationApi.getRecommendationAiBasedGoodList(displayCategoryNumber, channel, 12);
      const randomTags =
        interestList?.length > 3 ? interestList.sort(() => 0.5 - Math.random()).slice(0, 3) : interestList;
      setTags(randomTags);
      setGoodList(
        goodList?.map((it) => ({
          ...it,
          totalReviewScore: undefined,
        }))
      );
      handleVisibility?.(goodList?.length > 0);
    })();
  }, [displayCategoryNumber, channel, handleVisibility, login]);

  const mainTitle = useMemo(() => {
    const customTitle = title || '맞춤 상품을 AI가 추천해요';
    return `${customTitle}`;
  }, [title]);

  return (
    goodList?.length > 0 && (
      <>
        <Spacing width="100%" left={20} right={20}>
          <MainContentsTitle>{mainTitle}</MainContentsTitle>
          {tags?.length > 0 ? (
            <FlexBox padding={'14px 0 20px 0'} width={'100%'}>
              {tags?.map((tag) => (
                <FlexBox key={tag}>
                  <TextBox
                    height="17px"
                    textProps={{
                      weight: moTheme.font.weight.demiLight,
                      size: moTheme.font.size.$12,
                      color: theme.color.text.sub,
                      width: 'max-content',
                    }}
                  >
                    {`#${tag}`}
                  </TextBox>
                  <Spacing left="14px" />
                </FlexBox>
              ))}
            </FlexBox>
          ) : (
            <Spacing top={20} />
          )}
        </Spacing>
        <SwiperContents
          data-ds-label2={'reco_personal'}
          itemList={goodList}
          itemProps={{ width: '130px', height: 'auto', type: 'small' }}
          itemComponent={GoodCardCarouselItem}
          carouselProps={{
            slidesOffsetBefore: 20,
            loop: false,
            slidesPerView: 'auto',
            navigation: true,
            spaceBetween: 10,
          }}
        />
      </>
    )
  );
};

export default AiBasedRecommendation;

AiBasedRecommendation.propTypes = {
  title: PropTypes.string,
  displayCategoryNumber: PropTypes.string,
  channel: PropTypes.string,
  handleVisibility: PropTypes.func,
};
